import BetModel from "slotworks/model/bets/bet-model";
import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class SpinRequestPayload extends RequestPayload {
    public creditPerLine: number = BetModel.getCreditPerLine();
    public creditSize: number = BetModel.getCreditSize();
}
